/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_LANGUAGE_DETAILS_REQUEST,
  FETCH_LANGUAGE_DETAILS_SUCCESS,
  FETCH_LANGUAGE_DETAILS_FAILURE,
  FETCH_CURRENT_LANGUAGE_DETAILS
} from "./LanguageDetailsTypes";

const initialState = {
  loading: false,
  languages: [],
  currentLanguage:"",
  error: "",
};

const languageDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LANGUAGE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_LANGUAGE_DETAILS_SUCCESS:
      return {
        loading: false,
        languages: action.payload,
        currentLanguage:'',
        error: "",
      };
    case FETCH_LANGUAGE_DETAILS_FAILURE:
      return {
        loading: false,
        languages: {},
        error: action.payload,
        currentLanguage:''
      };
    case FETCH_CURRENT_LANGUAGE_DETAILS:
      return{
       ...state,
        currentLanguage:action.payload
      }
    default:
      return state;
  }
};

export default languageDetailsReducer;
